import parse from "html-react-parser";

const ErrorComponent = ({ msg ="Failed to load!" }) => {
  return (
    <p className="m-0">{parse(msg || "")}</p>
  )
}

export default ErrorComponent;